export default __webpack_public_path__ + "static/media/lydian-dark.96e33a3f.svg";